import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth }    from './hooks/useAuth';
import LandingPage    from './pages/LandingPage';
import ProfilePage    from './pages/ProfilePage';
import PrivacyPage    from './pages/PrivacyPage';
import TermsPage      from './pages/TermsPage';
import LegalModals    from './components/LegalModals';

// ── /register?ref=KOD → przekieruj na /?ref=KOD&openAuth=1 ────────────────
function RegisterRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref') ?? '';

  useEffect(() => {
    navigate(`/?ref=${refCode}&openAuth=1`, { replace: true });
  }, []);

  return null;
}

/** Normalizacja ścieżki (bez końcowego /), żeby "/" i "/privacy/" były przewidywalne. */
function normalizedPath(pathname) {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export default function App() {
  const location = useLocation();
  const { user, login, logout } = useAuth();
  // Splash 2,5 s TYLKO na landing "/" — na /privacy, /profile itd. od razu pełna aplikacja (inaczej po
  // zakończeniu timera z poprzedniej wizyty lub przy złym pierwszym odczycie pathname lądujesz na "*" → "/").
  const [isLoading, setIsLoading] = useState(() => {
    if (typeof window === 'undefined') return true;
    return normalizedPath(window.location.pathname) === '/';
  });
  const [showTerms,   setShowTerms]   = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    const path = normalizedPath(location.pathname);
    if (path !== '/') {
      setIsLoading(false);
      return;
    }
    const hasVisited = sessionStorage.getItem('vroom_visited');
    if (!hasVisited) {
      fetch('https://v-room.app/counter.php')
        .then(() => sessionStorage.setItem('vroom_visited', 'true'))
        .catch(() => {});
    }
    const t = setTimeout(() => setIsLoading(false), 2500);
    return () => clearTimeout(t);
  }, [location.pathname]);

  // NIGDY nie blokuj <Routes> loaderem — wtedy przy pierwszym mountcie po splashie router
  // dopiero wtedy widzi URL i potrafi źle spasować trasę → "*" → Navigate("/").
  // Splash tylko jako pełnoekranowa nakładka na stronie głównej "/".
  const showHomeSplash =
    isLoading && normalizedPath(location.pathname) === '/';

  return (
    <>
      <Routes>
        {/* Konkretne ścieżki przed "/" i przed "*", żeby nic nie przejęło wildcardem */}
        {/* /register?ref=KOD → automatyczny redirect */}
        <Route path="/register" element={<RegisterRedirect />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/privacy/" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/terms/" element={<TermsPage />} />
        <Route
          path="/profile"
          element={
            user
              ? <ProfilePage user={user} onLogout={logout} />
              : <Navigate to="/" replace />
          }
        />
        <Route
          path="/"
          element={
            <LandingPage
              user={user}
              onLogin={login}
              onShowTerms={() => setShowTerms(true)}
              onShowPrivacy={() => setShowPrivacy(true)}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {showHomeSplash && (
        <div
          className="loading-screen"
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 2147483647,
          }}
        >
          <div className="loading-container">
            <div className="vroom-logo-loader">
              <span className="material-icons">speed</span>
              <span className="vroom-text">VROOM</span>
            </div>
            <div className="loading-bar-container">
              <div className="loading-bar"></div>
            </div>
            <div className="loading-dots">
              <span /><span /><span />
            </div>
            <p className="loading-text">LOADING EXPERIENCE</p>
          </div>
          <div className="loading-grid"></div>
        </div>
      )}

      <LegalModals
        showTerms={showTerms}
        showPrivacy={showPrivacy}
        onCloseTerms={() => setShowTerms(false)}
        onClosePrivacy={() => setShowPrivacy(false)}
      />
    </>
  );
}